// Resmî hesap işareti (9.26 · D-641).
//
// Batuhan: *"meta ve x verified'daki gibi güzel bir mavi bir işaret olsun."*
//
// Tırtıklı kenarlı mavi rozet, içinde beyaz onay — Meta ve X'in kullandığı biçim;
// insanlar onu zaten "doğrulanmış" diye okuyor, yeni bir simge öğretmek
// gerekmiyor. Renk temadan bağımsız sabit: işaretin anlamı rengin kendisinde
// ve koyu temada da aynı mavi tanınıyor.
//
// Ekran okuyucu için "Resmî hesap" olarak duyuruluyor; görsel bir işaretin
// sesli karşılığı olmazsa, onu göremeyen biri resmî hesabı sıradan bir üyeden
// ayıramaz.
import React from 'react';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { View } from './rn';
import { useTranslation } from '../i18n/I18nContext';

export const VERIFIED_BLUE = '#1D9BF0';

type Props = { size?: number; testID?: string };

export default function VerifiedBadge({ size = 16, testID = 'verified-badge' }: Props) {
  const { t } = useTranslation();
  return (
    <View
      testID={testID}
      accessible
      accessibilityRole="image"
      accessibilityLabel={t('profile.officialAccount')}
      style={{ marginLeft: 4 }}>
      <MaterialIcons name="verified" size={size} color={VERIFIED_BLUE} />
    </View>
  );
}
